import { useState } from "react";
import TextField from "../../components/Textfield/TextField";
import { SidebarLeft } from "../../components/SidebarLeft/SidebarLeft";
import { AddProductCode } from "../../services/services";

const SidebarLeftAddCategoryCode = ({
  onClose,
  refetchProductCode,
  showSuccess,
}) => {
  const [addCategoryCode, setAddCategoryCode] = useState();

  return (
    <SidebarLeft onClose={onClose} width="w-auto ">
      <div style={{ width: "300px", display: "grid" }}>
        <h5 className="h-14 text-lg "> اضافه کردن دستبندی کد </h5>
        <div style={{ marginTop: "20px" }}>
          <TextField
            style={{ height: "40px" }}
            value={addCategoryCode}
            label={"نام دسته"}
            onChange={(e) => setAddCategoryCode(e.target.value)}
          />
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          style={{
            color: "#ffff",
            background: "#86a0ff",
            border: "0px",
            height: "39px",
            width: "100%",
            marginTop: "20px",
            borderRadius: "8px",
            padding: "2px",
          }}
          onClick={() =>
            AddProductCode({ title: addCategoryCode }).then(
              () => refetchProductCode(),
              showSuccess(" دسته کد با موفقیت اضافه شد "),
              onClose()
            )
          }
        >
          ثبت
        </button>
      </div>
    </SidebarLeft>
  );
};
export default SidebarLeftAddCategoryCode;
